<div class="overview__product isDesktop">
  <div class="table-responsive">
    <table class="table">
      <tbody class="table__item">
        <tr>
          <td>
            <label for="">{{'Tổ chức phát hành' | translate }}</label>
          </td>
          <td><span>{{product.owner?.shortName}}</span></td>
        </tr>
        <tr>
          <td>
            <label for="">{{'Tài sản đầu tư'  | translate}}</label>
          </td>
          <td><span>{{product.assets || '_'}}</span></td>
        </tr>
        <tr>
          <td><label for="">{{'Tài sản ròng'  | translate}}</label></td>
          <td><span>{{product.fundReport?.text || ''}}</span></td>
        </tr>
        <tr>
          <td>
            <label for="">{{'Ngày khớp lệnh'  | translate}}</label>
          </td>
          <td>
            <span>{{!product.productTradingSession?.transactionDateStr ? (product.transactionDate ? (product.transactionDate || '') + approveDays : '_') : product.productTradingSession?.transactionDateStr}}</span>
          </td>
        </tr>
        <tr>
          <td>
            <label for="">{{'Phiên khớp lệnh tiếp theo'  | translate}}</label>
          </td>
          <td>
            <span>{{product.productTradingSession?.tradingTimeString}}</span>
          </td>
        </tr>
        <tr>
          <td>
            <label for="">{{'Đặt lệnh và chuyển tiền mua'  | translate}}</label>
          </td>
          <td>
            <span>{{product.productTradingSession?.closedOrderBookString}}</span>
          </td>
        </tr>
        <tr *ngIf="product.customField">
          <td>
            <label for="">{{product.customField  | translate}}</label>
          </td>
          <td><span>{{product.customValue}}</span></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="block block-up isMobile">
  <div class="row">
    <div class="col-lg-3 col-sm-3 col-md-3 col-12">
      <div class="block-item">
        <label for="">{{'Tổ chức phát hành'  | translate}}</label>
        <span>{{product.owner?.shortName}}</span>
      </div>
    </div>
    <div class="col-lg-5 col-sm-5 col-md-5 col-12">
      <div class="block-item">
        <label for="">{{'Tài sản đầu tư'  | translate}}</label>
        <span>{{product.assets || '_'}}</span>
      </div>
    </div>
    <div class="col-lg-5 col-sm-5 col-md-5 col-12">
      <div class="block-item">
        <label for="">{{'Tài sản ròng' | translate}}</label>
        <span>{{product.fundReport?.text || '_'}}</span>
      </div>
    </div>
    <div class="col-lg-4 col-sm-4 col-md-4 col-12">
      <div class="block-item">
        <label for="">{{'Ngày khớp lệnh'  | translate}}</label>
        <span>{{product.transactionDate ? (product.transactionDate || '') + approveDays : '_'}}</span>
      </div>
    </div>
    <div class="col-lg-3 col-sm-3 col-md-3 col-12">
      <div class="block-item">
        <label for="">{{'Phiên khớp lệnh tiếp theo'  | translate}}</label>
        <span>{{product.productTradingSession?.tradingTimeString}}</span>
      </div>
    </div>
    <div class="col-lg-5 col-sm-5 col-md-5 col-12">
      <div class="block-item">
        <label for="">{{'Đặt lệnh và chuyển tiền mua'  | translate}}</label>
        <span>{{product.productTradingSession?.closedOrderBookString}}</span>
      </div>
    </div>
    <div class="col-lg-4 col-sm-4 col-md-4 col-12" *ngIf="product.customField">
      <div class="block-item">
        <label for="">{{product.customField  | translate}}</label>
        <span>{{product.customValue}}</span>
      </div>
    </div>
  </div>
</div>
<div class="fee-list">
  <div class="row">
    <div
      class="col-lg-6 col-sm-6 col-md-6 col-md-6 md--border__right"
      *ngIf="product.feeBuys?.length > 0"
      [ngClass]="!product.normalTimeHolds || ( product.normalTimeHolds && product.normalTimeHolds.length === 0) ? 'col-sm-6' : 'col-sm-12'"
    >
      <detail-fee [option]="optionBuyFee" [fees]="product.feeBuys"></detail-fee>
    </div>
    <div
      class="col-lg-6 col-sm-6 col-md-6"
      *ngIf="product.normalTimeHolds && product.normalTimeHolds.length > 0"
      [ngClass]="!product.feeBuys || ( product.feeBuys && product.feeBuys.length === 0) ? 'col-sm-6' : 'col-sm-12'"
    >
      <detail-fee [option]="optionSellFee" [fees]="product.normalTimeHolds"></detail-fee>
    </div>
  </div>
</div>
